import styled from '@emotion/styled'
import { Colors, Levels, Shapes } from 'src/components/theme'
import { MAP_FLOATING_WIDGET_SPACING } from 'src/components/theme/mapbox'
import { Fullscreen } from '@emotion-icons/material/Fullscreen'
import { FullscreenExit } from '@emotion-icons/material/FullscreenExit'
import { NO_PRINT_REPORTS } from 'src/utils/html-to-image'

type MapExpandControlProps = {
  expanded: boolean
  setExpanded: (expanded: boolean) => void
}

const MapExpandControlWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: ${Levels.mapLayerControl};
  position: absolute;
  right: ${MAP_FLOATING_WIDGET_SPACING}px;
  top: ${MAP_FLOATING_WIDGET_SPACING}px;
  user-select: none;
  box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
  border-radius: ${Shapes.borderRadius}px;
  cursor: pointer;
  background-color: ${Colors.bgWhite};
  width: 32px;
  height: 32px;
`

export const MapExpandControl = (props: MapExpandControlProps) => {
  const { expanded, setExpanded } = props

  const onClick = () => {
    setExpanded(!expanded)
  }

  return (
    <MapExpandControlWrapper className={NO_PRINT_REPORTS} onClick={onClick}>
      {expanded ? <FullscreenExit size={20} /> : <Fullscreen size={20} />}
    </MapExpandControlWrapper>
  )
}
